import axios from '@_system/axios/axios.js'
export default {
	path: '/parcel',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	listCheck(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/listCheck', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	listdetail(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/listdetail', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	
	
	listotherdetail(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path+'/listotherdetail', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	saveotherdetail(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/saveotherdetail', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	updateconfig(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/updateconfig', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	updateotherdetail(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/updateotherdetail', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delotherdetail(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/delotherdetail', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delconfig(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/delconfig', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	
	
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/delivery.parcel', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	synchronous(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/synchronous', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	getformconfig(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getformconfig', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	

	export(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			})
		})
	},
}
